import { TFAStatus } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { RequestType, web3Api } from 'store/queries';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';
import { createQueryFnWithErrorHandler } from 'store/utils/createQueryFnWithErrorHandler';

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchTFAStatus },
  useFetchTFAStatusQuery,
  useLazyFetchTFAStatusQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchTFAStatus: build.query<TFAStatus, void>({
      providesTags: [RequestType.TFAStatus],
      queryFn: createQueryFnWithErrorHandler({
        queryFn: async () => {
          const api = MultiService.getService().getAccountingGateway();

          const response = await api.getTFAStatus();
          const data = response['2FAs'][0].status;

          return { data };
        },
      }),
    }),
  }),
  overrideExisting: true,
});

const fetchTFAStatusFallback = TFAStatus.None;

export const {
  selectDataWithFallbackCachedByParams: selectTFAStatus,
  selectLoadingCachedByParams: selectTFAStatusLoading,
  selectStateCachedByParams: selectTFAStatusState,
} = createQuerySelectors({
  endpoint: fetchTFAStatus,
  fallback: fetchTFAStatusFallback,
});
